import { Injectable } from '@angular/core';
import { DigiAIXCoreAppState } from '../app-state';
import { Store } from '@ngrx/store';
import { FirestoreFormsState } from '../forms/forms.reducer';
import { selectFormsState } from '../forms/forms.selectors';
import { selectTablesState } from '../tables/table.selectors';
import { ActivatedRouteSnapshot } from '@angular/router';
import { FirestoreTableState } from '../tables/table-definition';

@Injectable({
  providedIn: 'root',
})
export class CurrentCollectionPathsService<Query> {
  private _tablesSnapshot: FirestoreTableState<any>;
  private _formsSnapshot: FirestoreFormsState;

  constructor(public store$: Store<DigiAIXCoreAppState>) {
    this.store$
      .select(selectFormsState)
      .subscribe((formsState) => (this._formsSnapshot = formsState));
    this.store$
      .select(selectTablesState)
      .subscribe((tablesState) => (this._tablesSnapshot = tablesState));
  }

  public get(state: ActivatedRouteSnapshot) {
    let load: Array<{ path: string; query?: Query }> = [];

    let curr = state;
    do {
      const loadRequests = [...(curr.data.load || [])];
      if (!curr.children.length) {
        if (curr.data.tableId && this._tablesSnapshot[curr.data.tableId]) {
          loadRequests.push(
            ...this._tablesSnapshot[curr.data.tableId].load,
            this._tablesSnapshot[curr.data.tableId].collectionPath,
          );
        }
        if (curr.data.formId && this._formsSnapshot[curr.data.formId]) {
          loadRequests.push(...this._formsSnapshot[curr.data.formId].load);
        }
      }
      for (let loadDocumentParams of loadRequests
        .filter((l) => !!l)
        .filter((l, i, s) => s.indexOf(l) === i)) {
        if (typeof loadDocumentParams === 'function') {
          loadDocumentParams = loadDocumentParams(curr);
        }
        if (typeof loadDocumentParams === 'string') {
          load.push({ path: loadDocumentParams });
        } else {
          load.push(loadDocumentParams);
        }
      }
      curr = curr.parent;
    } while (curr);

    load = load.filter(
      (l, index, self) =>
        self.findIndex((s) => s.path === l.path && s.query === l.query) ===
        index,
    );

    return load;
  }
}
